module.exports = __webpack_public_path__ + "assets/img/6076-al.svg";